// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import {
    getNotificationMentionRange,
    getNotificationMentionRangesAsArray,
    getNotificationMessage,
} from '../../../../../../../common/notifications/notificationModelUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';
import NotificationMessage from './NotificationMessage';
import StandardNotificationBoardTitle from './StandardNotificationBoardTitle';

const NotificationEntryMention = (props) => {
    const { actors, notification } = props;

    const message = getNotificationMessage(notification);
    const mentionRange = getNotificationMentionRange(notification);

    // Need to support mentions that occurred when only a single mention range was supported
    const mentionRanges = mentionRange ? [mentionRange] : getNotificationMentionRangesAsArray(notification);

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryMention"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-mention" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> mentioned you
                <StandardNotificationBoardTitle {...props} />
            </div>
            <NotificationMessage message={message} mentionRanges={mentionRanges} />
        </BaseNotificationEntry>
    );
};

NotificationEntryMention.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
};

export default NotificationEntryMention;
